/**
 * 产品卡同行槽位高度对齐：
 * 同一视觉行内，标题 / 价格 / 折扣码 / 按钮等取该行最大值；
 * 全行都是 1 行标题时不强制占 2 行，避免与价格间距过大。
 */
(function () {
  var ROOT_SELECTORS = [
    '[data-card-row-align]',
    '.product-grid-list',
    '.tab-products-grid',
    '.flash-sale-grid',
    '.activity-products-content',
    '.horizontal-product-cards-grid'
  ].join(',');

  var SLOT_SELECTORS = [
    '.product-card-slot--title',
    '.product-card-slot--extra',
    '.product-card-slot--price',
    '.product-card-slot--code',
    '.buy-and-learn',
    '.product-card-btn',
    '.horizontal-product-title',
    '.horizontal-product-price',
    '.horizontal-product-code',
    '.horizontal-product-actions'
  ];

  var ROW_TOLERANCE = 4;
  var aligning = false;
  var scheduled = new WeakMap();
  var observed = new WeakSet();

  function isVisible(el) {
    return !!(el && el.offsetParent !== null && el.getClientRects().length);
  }

  function getRoots(scope) {
    var base = scope && scope.querySelectorAll ? scope : document;
    return Array.prototype.slice.call(base.querySelectorAll(ROOT_SELECTORS)).filter(isVisible);
  }

  function getCards(root) {
    return Array.prototype.slice.call(root.children).filter(function (card) {
      if (!isVisible(card)) return false;
      return !!card.querySelector(
        '.product-card-slot--title, .horizontal-product-title, .buy-and-learn, .product-card-btn'
      );
    });
  }

  function resetCard(card) {
    SLOT_SELECTORS.forEach(function (selector) {
      var el = card.querySelector(selector);
      if (el) el.style.minHeight = '';
    });
  }

  function groupCardsByRow(cards) {
    var rows = [];
    cards.forEach(function (card) {
      var top = Math.round(card.getBoundingClientRect().top);
      var row = null;
      for (var i = 0; i < rows.length; i++) {
        if (Math.abs(rows[i].top - top) <= ROW_TOLERANCE) {
          row = rows[i];
          break;
        }
      }
      if (!row) {
        row = { top: top, cards: [] };
        rows.push(row);
      }
      row.cards.push(card);
    });
    return rows;
  }

  function equalizeRow(cards) {
    SLOT_SELECTORS.forEach(function (selector) {
      var els = cards
        .map(function (card) {
          return card.querySelector(selector);
        })
        .filter(Boolean);

      if (els.length < 2) return;

      var max = 0;
      els.forEach(function (el) {
        max = Math.max(max, el.offsetHeight);
      });

      if (max <= 0) return;

      els.forEach(function (el) {
        el.style.minHeight = max + 'px';
      });
    });
  }

  function alignRoot(root) {
    if (!root || !isVisible(root)) return;

    var cards = getCards(root);
    if (cards.length < 2) return;

    cards.forEach(resetCard);
    void root.offsetHeight;

    groupCardsByRow(cards).forEach(function (row) {
      if (row.cards.length > 1) equalizeRow(row.cards);
    });
  }

  function scheduleAlign(root) {
    if (!root || aligning) return;
    if (scheduled.get(root)) return;
    scheduled.set(root, true);
    requestAnimationFrame(function () {
      scheduled.set(root, false);
      aligning = true;
      try {
        alignRoot(root);
      } finally {
        requestAnimationFrame(function () {
          aligning = false;
        });
      }
    });
  }

  function observeRoot(root) {
    if (!root || observed.has(root) || typeof ResizeObserver === 'undefined') return;
    observed.add(root);
    var ro = new ResizeObserver(function () {
      scheduleAlign(root);
    });
    ro.observe(root);
  }

  function refresh(scope) {
    var roots = getRoots(scope || document);
    roots.forEach(function (root) {
      observeRoot(root);
      scheduleAlign(root);
    });
  }

  function init() {
    refresh(document);

    window.addEventListener(
      'resize',
      function () {
        refresh(document);
      },
      { passive: true }
    );

    document.addEventListener('click', function (event) {
      var tabButton = event.target.closest && event.target.closest('[data-tab-button]');
      if (!tabButton) return;
      requestAnimationFrame(function () {
        refresh(tabButton.closest('.shopify-section') || document);
      });
    });

    document.addEventListener('shopify:section:load', function (event) {
      refresh(event.target);
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        refresh(document);
      });
    }
  }

  window.ProductCardRowAlign = {
    refresh: refresh
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
